import 'bootstrap/dist/js/bootstrap.bundle.min';
import './js/fancybox.js';

jQuery(function($) {

    $('.category-select').select2({
        minimumResultsForSearch: Infinity,
    });

    // Handle change event of dropdown
    $('.mobile-filter-dropdown select').on('change', function () {
        var selectedValue = $(this).val();
        window.location.href = selectedValue;
    });

    // Wrap table to div
    $('table').wrap('<div class="table-responsive"></div>');

    jQuery(document).ready(function($) {
        var hoverTimeout;
    
        $('.menu-item-has-children').hover(
            function() {
                clearTimeout(hoverTimeout);
                $('.sub-menu').not($(this).find('.sub-menu')).fadeOut('fast');
                $(this).find('.sub-menu').fadeIn('fast');
                // $('.icn').toggleClass('icn-arrow-down icn-arrow-up-yellow');
            },
            function() {
                var $submenu = $(this).find('.sub-menu');
                if ($submenu.is(':visible')) { // Check if submenu is visible
                    hoverTimeout = setTimeout(function() {
                        $submenu.fadeOut('fast');
                    }, 200);
                }
            }
        );
    
        // Cancel the hover out event if moving from menu item to submenu
        $('.sub-menu').hover(
            function() {
                clearTimeout(hoverTimeout);
            },
            function() {
                var $submenu = $(this);
                if ($submenu.is(':visible')) { // Check if submenu is visible
                    hoverTimeout = setTimeout(function() {
                        $submenu.fadeOut('fast'); // Fade out the submenu
                        // $('.icn').toggleClass('icn-arrow-up-yellow icn-arrow-down');
                    }, 200); // Delay time before hiding submenu
                }
            }
        );
    });

    if ($(window).width() >= 991) {
        if ($('.cb-promo-bar').is(':visible')) {
            $('.side-menu-content, .sub-menu').css('top', '151px');
        }
        $('.close-bar').on('click', function() {
            $('.side-menu-content, .sub-menu').css('top', '95px');
        });
    } else if ($(window).width() < 991 && $(window).width() > 767) {
        if ($('.cb-promo-bar').is(':visible')) {
            $('.mobile-menu-content').css('top', '151px');
        }
        $('.close-bar').on('click', function() {
            $('.mobile-menu-content').css('top', '95px');
        });
    } else if ($(window).width() <= 767) {
        if ($('.cb-promo-bar').is(':visible')) {
            $('.mobile-menu-content').css('top', '138px');
        }
        $('.close-bar').on('click', function() {
            $('.mobile-menu-content').css('top', '70px');
        });
    }

    // Toggle side menu content on clicking side menu icon
    $(".side-menu").click(function() {
        var container = $(".side-menu-content");
        if (!container.is(":visible")) {
            container.fadeIn();
        } else {
            container.fadeOut();
        }
    });
    $(".mobile-menu").click(function() {
        var mobile_menu = $(".mobile-menu-content");
        if (!mobile_menu.is(":visible")) {
            mobile_menu.fadeIn();
        } else {
            mobile_menu.fadeOut();
        }
    });

    // Hide side menu content when clicking outside of it
    $(document).mouseup(function(e) {
        var container = $(".side-menu-content");
        var sideMenu = $(".side-menu");
        if (container.is(":visible") && !container.is(e.target) && container.has(e.target).length === 0 && !sideMenu.is(e.target) && !$(".icn-hamburger").is(e.target)) {
            container.fadeOut();
        }

    });

    jQuery(document).ready(function($) {
        // Track clicks for mobile
        var clickedOnce = false;
        $('.menu-item-has-children > a').on('click', function(e) {
            if ($(window).width() <= 991) {
                e.preventDefault();
                var $subMenu = $(this).siblings('.sub-menu');
                // If submenu is not visible, show it
                if (!clickedOnce) {
                    $subMenu.css('display', 'block');
                    clickedOnce = true;
                } else {
                    // If submenu is visible, open the link
                    window.location.href = $(this).attr('href');
                }
            }
        });
    });

    // For mobile menu first click open menu, second page
    // if (jQuery( window ).width() < 1239) {
    //     $('.menu-item-has-children').on("click", function(e) {
    //         if ($('.dropdown-menu').css('display') == 'block') {
    //             $(this).next('.dropdown-menu').css('display', 'none');
    //         } else {
    //             e.preventDefault();
    //             $(this).next('.dropdown-menu').css('display', 'block');
    //         }
    //     });
    // }

    new Swiper(".categoriesHeadingSwiper", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-projects-button-next",
            prevEl: ".swiper-projects-button-prev",
        },
    });

    new Swiper(".tabsHeadingSwiper", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-tabs-button-next",
            prevEl: ".swiper-tabs-button-prev",
        },
    });

    new Swiper(".tabsTextSwiper", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-tabs-button-next",
            prevEl: ".swiper-tabs-button-prev",
        },
    });

    new Swiper(".heroSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        pagination: {
            el: ".swiper-hero-pagination",
        },
        navigation: {
            nextEl: ".swiper-hero-button-next",
            prevEl: ".swiper-hero-button-prev",
        },
    });

    new Swiper(".newsSwiper", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-news-button-next",
            prevEl: ".swiper-news-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 25,
            }
        },
    });

    new Swiper(".projectsImageSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-projects-button-next",
            prevEl: ".swiper-projects-button-prev",
        },
    });

    new Swiper(".technologiesSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-technologies-button-next",
            prevEl: ".swiper-technologies-button-prev",
        },
    });
    new Swiper(".technologiesImageSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-technologies-button-next",
            prevEl: ".swiper-technologies-button-prev",
        },
    });

    new Swiper(".sliderTextRightSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-slider-image-button-next",
            prevEl: ".swiper-slider-image-button-prev",
        },
    });
    new Swiper(".sliderImageLeftSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-slider-image-button-next",
            prevEl: ".swiper-slider-image-button-prev",
        },
    });


    new Swiper(".reviewsimageSwiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination-reviews",
        },
        navigation: {
            nextEl: ".swiper-reviews-button-next",
            prevEl: ".swiper-reviews-button-prev",
        },
    });
    new Swiper(".reviewsSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination-reviews",
        },
        navigation: {
            nextEl: ".swiper-reviews-button-next",
            prevEl: ".swiper-reviews-button-prev",
        },
    });

    new Swiper(".indexReviewsSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination-index-reviews",
        },
        navigation: {
            nextEl: ".swiper-index-reviews-next",
            prevEl: ".swiper-index-reviews-prev",
        },
    });

    new Swiper(".sliderImageSwiper", {
        slidesPerView: 2,
        spaceBetween: 64,
        pagination: {
          el: ".swiper-pagination-slider",
        },
        navigation: {
            nextEl: ".swiper-slider-button-next",
            prevEl: ".swiper-slider-button-prev",
        },
    });

    new Swiper(".gallerySwiper", {
        slidesPerView: 1,
        spaceBetween: 32,
        pagination: {
          el: ".swiper-pagination-gallery",
        },
        navigation: {
            nextEl: ".swiper-gallery-button-next",
            prevEl: ".swiper-gallery-button-prev",
        },
        breakpoints: {
            800: {
                slidesPerView: 2,
                spaceBetween: 64,
            }
        },
    });

    new Swiper(".serviceGallerySwiper", {
        slidesPerView: 1,
        spaceBetween: 32,
        pagination: {
          el: ".swiper-pagination-service-gallery",
        },
        navigation: {
            nextEl: ".swiper-service-gallery-button-next",
            prevEl: ".swiper-service-gallery-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            }
        },
    });

    new Swiper(".sliderSwiper", {
        slidesPerView: 1,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        pagination: {
            el: ".swiper-pagination-slider",
        },
        navigation: {
            nextEl: ".swiper-slider-button-next",
            prevEl: ".swiper-slider-button-prev",
        },
    });

    new Swiper(".employeeReviewsSwiper", {
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-employee-reviews-button-next",
            prevEl: ".swiper-employee-reviews-button-prev",
        },
    });

    new Swiper(".jobOffersSwiper", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-job-button-next",
            prevEl: ".swiper-job-button-prev",
        },
    });

    new Swiper(".jobOffersMobileSwiper", {
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination-job-offers-mobile",
        },
        navigation: {
            nextEl: ".swiper-job-offers-mobile-next",
            prevEl: ".swiper-job-offers-mobile-prev",
        },
    });

    $('.accordion-cell').click(function() {
        // Check if the clicked cell is already expanded
        if ($(this).hasClass('expanded')) {
            // If already expanded, return without performing any further actions
            return;
        }
    
        if ($(this).hasClass('collapsed')) {
            $(this).removeClass('collapsed');
            $(this).siblings().removeClass('expanded');
            $(this).addClass('expanded');
            $(this).siblings().addClass('collapsed');
        } else {
            $(this).toggleClass('expanded');
            $(this).siblings().toggleClass('collapsed');
        }
    });

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
    }
    
    $('.cb-promo-bar a.close-bar').click(function () {
        setCookie('cb-promo-bar', 'hide', 30);
        $('.cb-promo-bar').fadeOut('fast');
    });

    // Function to call YouTube Player API functions
    function callPlayer(func, args) {
        var iframes = document.getElementsByTagName('iframe');
        for (var i = 0; i < iframes.length; ++i) {
            if (iframes[i]) {
                var src = iframes[i].getAttribute('src');
                if (src && src.indexOf('youtube.com/embed') !== -1) {
                    iframes[i].contentWindow.postMessage(JSON.stringify({
                        'event': 'command',
                        'func': func,
                        'args': args || []
                    }), "*");
                }
            }
        }
    }

    // Function to stop the YouTube video
    function stopYouTubeVideo() {
        callPlayer('stopVideo');
    }

    // Event listener for the modal shown event
    $('#videoModal').on('shown.bs.modal', function () {
        // Autoplay the YouTube video when the modal is opened
        callPlayer('playVideo');
    });

    // Event listener for the modal hidden event
    $('#videoModal').on('hidden.bs.modal', function () {
        // Stop the YouTube video when the modal is closed
        stopYouTubeVideo();
    });

    new Swiper(".indexProjectsSwiper", {
        slidesPerView: 1,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-projects-button-next",
            prevEl: ".swiper-projects-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        }
    });

    new Swiper(".projectsSwiper", {
        slidesPerView: 1,
        loop: true,
        watchOverflow: true,
        fadeEffect: { crossFade: true },
        speed: 500,
        effect: 'fade',
        navigation: {
            nextEl: ".swiper-projects-button-next",
            prevEl: ".swiper-projects-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        }
    });

});